<template>
  <div>
    <page-header header="Create user" />

    <user-form
      ref="form"
      :user="{
        all_subscriptions: [],
        country: null,
        account: null,
        channels: [],
        permissions: [],
        all_roles: [],
        user_role: null,
        interests: null,
      }"
      :alert-lists="[]"
      :all-alert-lists="alertLists"
      @save-success="saveComplete"
    />

    <save-bar
      class="mb-4"
      :show-delete="false"
      @save="$refs.form.save()"
    />
  </div>
</template>

<script>
import UserForm from './Form'
import SaveBar from '@/components/SaveBar'
import {successNotification} from '@/notifications'

export default {
  components: {
    UserForm,
    SaveBar,
  },

  data () {
    return {
      alertLists: [],
    }
  },

  mounted () {
    this.$http.get('/alert-lists').then((response) => {
      this.alertLists = response.data.data
    })
  },

  methods: {
    saveComplete (response) {
      this.$notify(successNotification(`Created ${response.data.data.first_name}`))
      if (this.$route.query.onComplete) {
        this.$router.replace({path: this.$route.query.onComplete})
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

